import { asVideoKind } from "../../components/Video/video";
export const DrupalMediaToVideo = (media)=>{
    const field = media.field_media;
    if (field.bundle != 'video') {
        throw new Error(`The media type ${field.bundle} is not supported`);
    }
    return DrupalEmbedToVideo(field.field_media_video_embed_field, media.field_media.label);
};
export const DrupalEmbedToVideo = (embed, name)=>{
    const [kind, valid] = asVideoKind(embed.type, 'html5');
    if (!valid) console.error(`Unsupported video type ${embed.type}, defaulting to 'html5'`);
    const video = {
        Kind: kind,
        Url: embed.iframe_url,
        VideoName: name
    };
    return video;
};
